<template>
  <div class="war-room-post-official-header">
    <BravadoLogoIcon class="war-room-post-official-header__icon" />
    <div class="war-room-post-official-header__title">Official thread</div>
    <div class="war-room-post-official-header__actions">
      <WarRoomPostActions :post="post" class-name="war-room-post-official-header__menu" />
    </div>
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import BravadoLogoIcon from './images/bravado-logo.vue.svg';
import WarRoomPostActions from '@/components/partials/war-room/WarRoomPostActions.vue';
import type { IPost } from '@/types/community';

export default Vue.extend({
  name: 'WarRoomPostOfficialHeader',
  components: {
    WarRoomPostActions,
    BravadoLogoIcon,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
});
</script>

<style scoped lang="scss">
.war-room-post-official-header {
  height: 60px;
  background: rgba(var(--black));
  margin: -16px -16px 28px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  @include mq('sm') {
    margin: -28px -24px 28px;
  }

  &__icon {
    margin-right: 16px;
  }

  &__title {
    @include body-semibold;

    color: rgba(var(--white));
  }

  &__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  ::v-deep {
    .war-room-post-actions__icon {
      color: rgba(var(--white)) !important;
    }

    &__menu {
      line-height: 0;
      color: rgba(var(--white)) !important;
      padding-left: 12px;

      &:hover {
        color: rgba(var(--white)) !important;
      }
    }
  }
}
</style>
